import moment from "moment";
import LostDeal from "../../../../mainDeals/deals/deal/lost-deal/lost-form-deal";
import DealQuickView from "../../../../mainDeals/deals/deal/popup";
import WonDeal from "../../../../mainDeals/deals/deal/won-deal/won-form-deal";
import EmployeeDirectoryAddUpdate from "../../../../organization/emplyee-directory/add-update";
import {
  Calendar,
  Clock,
  Copy,
  CopyCheck,
  Settings2,
  ThumbsDown,
  ThumbsUp,
  Trophy,
  User,
  XCircle,
  Pencil,
  Lock,
  Check,
  X,
  PlusIcon,
  ChevronDown,
  Loader2,
} from "lucide-react";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import Swal from "sweetalert2";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import { Suspense, useState, useEffect, useRef } from "react";
import Style from "../style.module.css";
import CustomizeTabsOverviewPopup from "./customize-tabs-popup";
import { useMemo } from "react";
// import FilesTab from "../../../../../component/files";
import CommentsSection from "../../../../../component/comment";
// import ProjectQuickView from "../../../../projects/project/popup";
import AddBrief from "./add-brief";
import Tooltip from "../../../../../component/ui/tooltip";
import { Alert, Snackbar } from "@mui/material";
import ProjectQuickView from "../../../../mainProjects/projects/project/popup";
import FilesTab from "./files";
// import CommentsSection from "./comments";
import Icon from "../../../../../component/icons/inner-pages-icons";
import FollowUpPopup from "../../follow-ups";
import {
  FollowUpsTab,
  TimelineTab,
} from "../../../../../component/ui/timeline";

const CopyIcon = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 3000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <div
        className="ms-2 hover:opacity-50 cursor-pointer transition-all"
        onClick={() => {
          copyToClipboard(text);
        }}
      >
        {isCopied ? (
          <CopyCheck size={15} color="#333" />
        ) : (
          <Copy size={15} color="#333" />
        )}
      </div>
    </>
  );
};

function NewField({ label, value, icon: Icon }) {
  const [isActive, setIsActive] = useState(false);
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));
  const [showAll, setShowAll] = useState(false);

  const limit = 70;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";
  return (
    <div>
      {isUrl ? (
        <>
          <div className="flex flex-col gap-y-[10px]">
            <div className="flex gap-[10px] items-center">
              {Icon ? (
                <span>{Icon ? <Icon size={16} /> : <User size={16} />} </span>
              ) : null}
              <p className="text-xs font-medium">{label}</p>
            </div>

            <div className="flex justify-between text-[14px] w-full font-normal text-[#999] min-w-0">
              <a
                href={value}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:underline break-all whitespace-normal min-w-0"
              >
                {value?.length > 50 ? `${value?.slice(0, 30)}...` : value}
              </a>

              <CopyIcon text={value} />
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-y-[10px]">
          <div className="flex gap-[10px] items-center">
            {Icon ? (
              <span>{Icon ? <Icon size={16} /> : <User size={16} />} </span>
            ) : null}
            <p className="text-xs font-medium">{label}</p>
          </div>

          {/* <div className="text-sm font-medium text-[rgba(14,18,27,0.40)]">
            {value}
          </div> */}
          {/* Value */}
          <div className="text-sm font-medium text-[rgba(14,18,27,0.40)] break-words whitespace-normal">
            {displayText}

            {isLongText && (
              <button
                onClick={() => setShowAll(!showAll)}
                className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
              >
                {showAll ? "Show less" : "Show more"}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// const statusColor = {
//   pending: "bg-amber-50 text-amber-700 border border-amber-200",

//   in_progress: "bg-blue-50 text-blue-700 border border-blue-200",

//   revision: "bg-purple-50 text-purple-700 border border-purple-200",

//   on_hold: "bg-rose-50 text-rose-700 border border-rose-200",

//   completed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
// };

const statusColor = {
  completed: { background: "#E6F9F0", color: "#0F9D58" }, // emerald green
  on_hold: { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
  pending: { background: "#fff3e0", color: "#e65100" }, // deep orange
  in_progress: { background: "#F3E8FF", color: "#9333EA" }, // violet
  revision: { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
  "no answer update 2": { background: "#f3f4f6", color: "#374151" }, // cyan / teal
  "wrong number": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "call back": { background: "#fffbeb", color: "#78350f" }, // cyan / teal
  "not interested": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
  "do not contact": { background: "#f9fafb", color: "#374151" }, // cyan / teal
  duplicate: { background: "#ede9fe", color: "#5b21b6" },
};

const T = {
  bg: "#EDE8E1",
  sidebar: "#1a1730",
  sidebarHover: "#252240",
  sidebarActive: "#302d4a",
  card: "#FFFFFF",
  cardBorder: "rgba(0,0,0,0.08)",
  text: "#1a1520",
  textSecondary: "#5c5466",
  textMuted: "#908892",
  accent: "#6366f1",
  accentLight: "rgba(99,102,241,0.08)",
  accentText: "#5457e5",
  shadow: "0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)",
  shadowMd: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
  shadowLg: "0 8px 30px rgba(0,0,0,0.08)",
  inputBg: "#F3EFE9",
  inputBorder: "rgba(0,0,0,0.1)",
};

const STATUS_COLORS = {
  "Need Analysis": "#f59e0b",
  "Value Proposition": "#3b82f6",
  "Identify Decision": "#8b5cf6",
  Proposal: "#06b6d4",
  Review: "#10b981",
  "Closed Won": "#22c55e",
  Won: "#22c55e",
  "Closed Lost": "#ef4444",
  Lost: "#ef4444",
};

const STAGES = [
  "Need Analysis",
  "Value Proposition",
  "Identify Decision",
  "Proposal",
  "Review",
  "Won",
  "Lost",
];

function NewMetaField({ label, value }) {
  const isUrl =
    typeof value === "string" &&
    (value.startsWith("http://") || value.startsWith("https://"));
  const [showAll, setShowAll] = useState(false);

  const limit = 60;
  const isLongText = value?.length > limit;

  const displayText =
    !isLongText || showAll ? value : value.slice(0, limit) + "...";
  return isUrl ? (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 0",
          borderBottom:
            // i < 6 ? `1px solid ${T.cardBorder}` : "none",
            `1px solid ${T.cardBorder}`,
        }}
      >
        <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

        <div className="flex justify-between font-mono text-[13px]  font-medium text-[#1a1520] min-w-0">
          <a
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:underline break-all whitespace-normal min-w-0"
          >
            {value?.length > 50 ? `${value?.slice(0, 30)}...` : value}
          </a>

          <CopyIcon text={value} />
        </div>
      </div>
    </>
  ) : (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 0",
        borderBottom:
          // i < 6 ? `1px solid ${T.cardBorder}` : "none",
          `1px solid ${T.cardBorder}`,
      }}
    >
      <div style={{ fontSize: 12, color: T.textMuted }}>{label}</div>

      {/* Value */}
      <div className="text-[13px]  font-medium text-[#1a1520] break-words whitespace-normal max-w-[80%]">
        {displayText || "-"}

        {isLongText && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="ml-1 text-[#0057FB] text-xs font-medium hover:underline"
          >
            {showAll ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
  );
}

// ─── HELPERS ───
const activityIcons = {
  call: "phone",
  phone: "phone",
  email: "mail",
  sms: "sms",
  consultation: "consultation",
  default: "default",

  note: "note",
  meeting: "calendar",
  "follow-up": "calendar",
  followup: "calendar",
  stage: "arrowRight",
  voicemail: "mic",
  chat: "sms",
  comment: "sms",
  demo: "demo",
  messasge: "sms",
  presentation: "presentation",
  assign: "assign",
  unassign: "unassign",
  file: "file",
  brief: "brief",
};

const activityColors = {
  call: "#3b82f6", // blue
  email: "#8b5cf6", // violet
  sms: "#06b6d4", // cyan
  consultation: "#f59e0b", // amber
  note: "#f59e0b", // amber
  meeting: "#10b981", // emerald
  stage: "#6366f1", // indigo
  // "follow-up": "#6366f1", // indigo
  "follow-up": "#06b6d4", // indigo
  voicemail: "#ef4444", // red

  chat: "#0ea5e9", // sky blue
  presentation: "#14b8a6", // teal
  demo: "#a855f7", // purple
  default: "#a855f7", // purple
  messasge: "#f43f5e", // rose

  // remaining icons (added)
  phone: "#3b82f6", // blue
  comment: "#0ea5e9", // sky
  followup: "#06b6d4", // indigo
  assign: "#22c55e", // green
  unassign: "#ef4444", // red
  file: "#eab308", // slate
  brief: "#eab308", // yellow
};
const priorityColors = { high: "#ef4444", medium: "#f59e0b", low: "#10b981" };

// ─── COMPONENTS ───

const Badge = ({ color, children, style = {} }) => (
  <span
    style={{
      display: "inline-flex",
      flexShrink: 0,
      alignItems: "center",
      gap: 4,
      padding: "3px 10px",
      borderRadius: 6,
      fontSize: 11,
      fontWeight: 600,
      background: color + "14",
      color,
      letterSpacing: "0.3px",
      ...style,
    }}
  >
    {children}
  </span>
);

const Card = ({ children, style = {}, hover = false, onClick }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => hover && setHovered(true)}
      onMouseLeave={() => hover && setHovered(false)}
      style={{
        background: T.card,
        border: `1px solid ${T.cardBorder}`,
        borderRadius: 12,
        boxShadow: hovered ? T.shadowMd : T.shadow,
        transform: hovered ? "translateY(-1px)" : "none",
        transition: "all 0.15s ease",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const ActionButton = ({
  icon,
  label,
  color = T.accent,
  variant = "outline",
  onClick,
  style = {},
}) => {
  const [hovered, setHovered] = useState(false);
  const filled = variant === "filled";
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "10px 16px",
        borderRadius: 10,
        border: filled ? "none" : `1px solid ${color}30`,
        background: filled
          ? hovered
            ? color
            : color + "ee"
          : hovered
            ? color + "10"
            : color + "06",
        color: filled ? "#fff" : color,
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 600,
        fontFamily: "inherit",
        transition: "all 0.15s",
        width: "100%",
        boxShadow: filled ? `0 2px 8px ${color}35` : "none",
        ...style,
      }}
    >
      <Icon name={icon} size={15} color={filled ? "#fff" : color} /> {label}
    </button>
  );
};
export function StatusField({ label, value, onChange, statusList = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(value);
  const dropdownRef = useRef(null);

  const selected = statusList?.find((s) => s.id == current) || statusList[0];

  // Outside click close
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = async (status) => {
    if (status?.id == current) return setIsOpen(false);

    const previousStatus = current;

    setCurrent(status?.id);
    setIsOpen(false);
    setLoading(true);
    try {
      await onChange(status?.id); // your API call
    } catch (err) {
      console.error(err);
      setCurrent(previousStatus);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-2" ref={dropdownRef}>
      {/* <p className="text-sm font-medium text-gray-500">{label}</p> */}

      <div className="relative inline-block">
        {/* Badge */}
        <div
          onClick={() => !loading && setIsOpen(!isOpen)}
          className={`flex items-center gap-2 px-2 py-1 rounded-full cursor-pointer transition-all duration-200 
            hover:shadow-md hover:scale-[1.02]`}
          style={
            statusColor[selected?.id?.toLowerCase()] || {
              background: "#f5f5f5",
              color: "#616161",
            }
          }
        >
          {/* ${statusColor[selected?.id] || "bg-gray-100 text-gray-600 border border-gray-200"} */}
          {loading ? (
            <Loader2 className="animate-spin w-4 h-4" />
          ) : (
            <>
              <span className="text-sm font-semibold">{selected?.value}</span>
              <ChevronDown className="w-4 h-4 opacity-70" />
            </>
          )}
        </div>

        {/* Dropdown */}
        {isOpen && (
          <div className="absolute mt-1 w-32 bg-white rounded-2xl shadow-xl border border-[#e1e4ea] p-1 z-50 animate-in fade-in zoom-in-95 duration-150">
            {statusList?.map((status) => (
              <div
                key={status.value}
                onClick={() => handleSelect(status)}
                className="px-3 py-2 rounded-xl text-sm hover:bg-gray-100 cursor-pointer transition"
              >
                {status.value}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const Project = ({
  leadDetail,
  DealStages = [],
  onSuccess = () => {},
  onError = () => {},
  activeProjectData = {},
  statusList = [],
  onChange = () => {},
}) => {
  const [projPopup, setProjPopup] = useState(false);
  const [projData, setProjData] = useState({});

  const metas = Object.fromEntries(
    activeProjectData?.metas?.map((m) => [m.meta_key, m.meta_value]) ?? [],
  );

  const campaignKeys = [
    "parent_url",
    "user_agent",
    "campaigned",
    "is_dropoff",
    "adgroupid",
    "keyword",
    "device",
    "matchtype",
    "msclkid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
    "gclid",
  ];

  const excludeKeys = [
    "name",
    "email",
    "phone",
    "lead_source",
    "leadstatus",
    "leadtime",
    "country",
    "date",
  ];

  const campaignMeta = activeProjectData?.metas?.filter((m) =>
    campaignKeys.includes(m.meta_key),
  );

  const otherMeta = activeProjectData?.metas?.filter(
    (m) =>
      !campaignKeys.includes(m.meta_key) && !excludeKeys.includes(m.meta_key),
  );

  function extractListItems(html) {
    console.log("features", html);

    if (!html) return [];

    return (
      html
        ?.replace(/<\/?ul>/g, "") // remove <ul> tags
        ?.match(/<li>(.*?)<\/li>/g) // get all <li>
        ?.map((item) => item.replace(/<\/?li>/g, "").trim()) || []
    );
  }

  return (
    <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto relative">
      <div className="flex flex-col gap-y-[17px]">
        {/* Project DETAILS */}
        {/* <div className="bg-white rounded-[10px] border border-[#e1e4ea] p-5">
          <div className="flex flex-col gap-y-[10px]">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-medium leading-normal">
                Project Details
              </h2>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
                <NewField
                  label="Name"
                  value={activeProjectData?.customer_details?.name}
                />

                <NewField
                  label="Email"
                  value={activeProjectData?.customer_details?.email}
                />

                <NewField
                  label="Phone"
                  value={activeProjectData?.customer_details?.phone}
                />
                <NewField
                  label="Start Date"
                  value={activeProjectData?.startdate}
                />
              </div>

              <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
                <StatusField
                  label="Project Status"
                  value={activeProjectData?.status}
                  onChange={onChange}
                  statusList={statusList}
                />
                <NewField
                  label="Invoice Id"
                  value={activeProjectData?.invoiceid}
                />
                <NewField
                  label="Project Cost"
                  value={activeProjectData?.projectcost}
                />

                <NewField
                  label="Project Key"
                  value={activeProjectData?.projectkey}
                />
              </div>
            </div>
            <div className="flex items-center justify-between">
             
            </div>
          </div>
        </div> */}

        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}
        >
          <Card style={{ padding: 20 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 700 }}>
                Project Details
              </span>
            </div>
            {[
              {
                label: "Name",
                value: activeProjectData?.customer_details?.name || "-",
              },
              {
                label: "Email",
                value: activeProjectData?.customer_details?.email,
                action: true,
                isUrl: true,
                url: `mailto:${activeProjectData?.customer_details?.email}`,
              },
              {
                label: "Phone",
                value: activeProjectData?.customer_details?.phone,
                action: true,
                isUrl: true,
                url: `tel:${activeProjectData?.customer_details?.phone}`,
              },
              {
                label: "Project Cost",
                value: activeProjectData?.projectcost || "-",
                highlight: true,
              },
              {
                label: "Project Status",
                value: activeProjectData?.status || "-",
                IsStatus: true,
              },

              // {
              //   label: "Current Status",
              //   value: activeDealData?.current_stage?.dealstatus,
              //   badge: true,
              //   color: STATUS_COLORS[activeDealData?.current_stage?.dealstatus],
              // },
              {
                label: "Invoice Id",
                value: activeProjectData?.invoiceid || "-",
              },

              {
                label: "Start Date",
                value: activeProjectData?.startdate || "-",
              },
              {
                label: "Project Key",
                value: activeProjectData?.projectkey || "-",
                mono: true,
              },
            ].map((field, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 0",
                  borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
                }}
              >
                <span style={{ fontSize: 12, color: T.textMuted }}>
                  {field.label}
                </span>

                {field?.IsStatus ? (
                  // <StatusField
                  //   label={field?.label}
                  //   value={field?.value}
                  //   onChange={onChange}
                  //   statusList={statusList}
                  // />

                  <div
                    className={`inline-block w-auto text-[11px]  font-bold  gap-2 px-[10px] py-[3px] rounded-full cursor-pointer transition-all duration-200 
                       `}
                    // ${statusColor[field?.value] || "bg-gray-100 text-gray-600 border border-gray-200"}
                    style={
                      statusColor[field?.value?.toLowerCase()] || {
                        background: "#f5f5f5",
                        color: "#616161",
                      }
                    }
                  >
                    {field?.value
                      ? field?.value
                          ?.split("_")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1),
                          )
                          .join(" ")
                      : null}
                  </div>
                ) : field.badge ? (
                  <Badge color={field.color}>{field.value}</Badge>
                ) : (
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: field.highlight ? 700 : 500,
                      color: field.highlight
                        ? "#22c55e"
                        : field.action
                          ? T.accentText
                          : T.text,
                      fontFamily: field.mono ? "monospace" : "inherit",
                      fontSize: field.mono ? 11 : 13,
                      cursor: field.action ? "pointer" : "default",
                    }}
                  >
                    {field?.isUrl ? (
                      <a href={field?.url}>{field?.value}</a>
                    ) : (
                      field.value
                    )}
                  </span>
                )}
              </div>
            ))}
          </Card>

          {/* <Card style={{ padding: 20 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 700 }}>
                Agent Details
              </span>
            </div>
            {[
              {
                label: "Name",
                value: activeProjectData?.agent_details?.name || "-",
              },
              {
                label: "Email",
                value: activeProjectData?.agent_details?.email || "-",
                action: true,
              },
              {
                label: "Phone",
                value: activeProjectData?.agent_details?.phone || "-",
                action: true,
              },

              {
                label: "Source",
                value: activeProjectData?.agent_details?.source,
              },
              {
                label: "Page Source",
                value: activeProjectData?.agent_details?.page_source,
              },
              {
                label: "Created At",
                value: activeProjectData?.agent_details?.signupdate,
              },
            ].map((field, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 0",
                  borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
                }}
              >
                <span style={{ fontSize: 12, color: T.textMuted }}>
                  {field.label}
                </span>
                {field.badge ? (
                  <Badge color={field.color}>{field.value}</Badge>
                ) : (
                  <span
                    style={{
                      fontSize: 13,
                      fontWeight: field.highlight ? 700 : 500,
                      color: field.highlight
                        ? "#22c55e"
                        : field.action
                          ? T.accentText
                          : T.text,
                      fontFamily: field.mono ? "monospace" : "inherit",
                      fontSize: field.mono ? 11 : 13,
                      cursor: field.action ? "pointer" : "default",
                    }}
                  >
                    {field.value}
                  </span>
                )}
              </div>
            ))}
          </Card> */}
          {/* Package Details */}
          <Card style={{ padding: 20 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <span style={{ fontSize: 14, fontWeight: 700 }}>
                Package Details
              </span>
            </div>
            {[
              {
                label: "Package Name",
                value: activeProjectData?.package_details?.packagename || "-",
              },
              {
                label: "Product Name",
                value:
                  activeProjectData?.package_details?.main_product?.products ||
                  "-",
              },
              {
                label: "Amount",
                value: `$${activeProjectData?.package_details?.amount}` || "-",
                highlight: true,
              },

              {
                label: "Discount",
                value: `${activeProjectData?.package_details?.discount}%`,
              },
              {
                label: "Number Of Revisions",
                value: activeProjectData?.package_details?.numberofrevisions,
              },
              {
                label: "Features",
                value: activeProjectData?.package_details?.features,
                isFeatures: true,
              },
            ].map((field, i) => {
              //               const points = field?.value?.match(/<li>(.*?)<\/li>/g)?.map(item =>
              //   item?.replace(/<\/?li>/g, "").trim()
              // );
              let features;
              if (field?.isFeatures) {
                features = extractListItems(field?.value);
              }

              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 0",
                    borderBottom: i < 6 ? `1px solid ${T.cardBorder}` : "none",
                  }}
                >
                  <span style={{ fontSize: 12, color: T.textMuted }}>
                    {field.label}
                  </span>
                  {field?.isFeatures ? (
                    <ul className="list-disc list-inside space-y-1 grid grid-cols-2 ">
                      {features?.map((item, index) => (
                        <li
                          key={index}
                          className="marker:text-[#2563eb]"
                          style={{ fontSize: 12, color: T.textMuted }}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  ) : field.badge ? (
                    <Badge color={field.color}>{field.value}</Badge>
                  ) : (
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: field.highlight ? 700 : 500,
                        color: field.highlight
                          ? "#22c55e"
                          : field.action
                            ? T.accentText
                            : T.text,
                        fontFamily: field.mono ? "monospace" : "inherit",
                        fontSize: field.mono ? 11 : 13,
                        cursor: field.action ? "pointer" : "default",
                      }}
                    >
                      {field.value}
                    </span>
                  )}
                </div>
              );
            })}
          </Card>
        </div>

        {/* Agent Details */}

        {/* <div className="bg-white rounded-[10px] border border-[#e1e4ea] p-5 flex flex-col gap-[10px]">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-medium leading-normal">
              Agent Details
            </h2>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
              <NewField
                label="Name"
                value={activeProjectData?.agent_details?.name}
              />

              <NewField
                label="Email"
                value={activeProjectData?.agent_details?.email}
              />

              <NewField
                label="Phone"
                value={activeProjectData?.agent_details?.phone}
              />
            </div>

            <div className="py-[17px] flex flex-col gap-y-[34px] col-span-1">
              <NewField
                label="Page Source"
                value={activeProjectData?.agent_details?.page_source}
              />
              <NewField
                label="Source"
                value={activeProjectData?.agent_details?.source}
              />
              <NewField
                label="Created At"
                value={activeProjectData?.agent_details?.signupdate}
              />
            </div>
          </div>
        </div> */}

        {projPopup && (
          <ProjectQuickView
            onClose={() => {
              setProjPopup(false);
              setProjData({});
            }}
            data={projData}
          />
        )}
      </div>
    </div>
  );
};

// const FollowUpsTab = ({
//   leadDetail,
//   onSuccess = () => { },
//   onError = () => { },
//   activeProjectData = {},
//   UserList = [],
//   onFollowUpSuccess = () => { },
// }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   return (
//     <>
//       <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto">
//         <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//           <Card
//             style={{
//               padding: "12px 16px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             <span style={{ fontSize: 13, fontWeight: 600 }}>
//               Scheduled Follow-Ups
//             </span>
//             <ActionButton
//               icon="plus"
//               label="New Follow-Up"
//               variant="filled"
//               style={{ width: "auto", padding: "7px 14px", fontSize: 12 }}
//               onClick={() => {
//                 if (typeof setSelectedActivity === "function") {
//                   setSelectedActivity(null);
//                 }
//                 if (typeof setShowActivityModal === "function") {
//                   setShowActivityModal(true);
//                 }
//               }}
//             />
//           </Card>
//           {activeProjectData?.schedules.length > 0 ? (
//             activeProjectData?.schedules?.map((f) => (
//               <Card
//                 key={f.id}
//                 hover
//                 style={{ padding: "14px 18px" }}
//                 onClick={() => {
//                   setSelectedActivity(f);
//                   setShowActivityModal(true);
//                 }}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//                   <div
//                     style={{
//                       width: 10,
//                       height: 10,
//                       borderRadius: "50%",
//                       background:
//                         f.status?.toLowerCase() === "completed"
//                           ? "#22c55e"
//                           : priorityColors[f.priority],
//                       boxShadow:
//                         f.status?.toLowerCase() === "completed"
//                           ? "none"
//                           : `0 0 0 3px ${priorityColors[f.priority]}20`,
//                     }}
//                   />
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 13,
//                         fontWeight: 600,
//                         color: T.text,
//                         textDecoration:
//                           f.status.toLowerCase() === "completed"
//                             ? "line-through"
//                             : "none",
//                         opacity: f.status === "completed" ? 0.6 : 1,
//                       }}
//                     >
//                       {f?.note}
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         gap: 12,
//                         marginTop: 4,
//                         fontSize: 11,
//                         color: T.textMuted,
//                       }}
//                     >
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="calendar" size={11} color={T.textMuted} />{" "}
//                         {f?.due_date}
//                       </span>
//                       <span
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                         }}
//                       >
//                         <Icon name="clock" size={11} color={T.textMuted} />{" "}
//                         {f?.due_time}
//                       </span>
//                     </div>
//                   </div>
//                   <Badge color={priorityColors[f.priority]}>{f.priority}</Badge>
//                 </div>
//               </Card>
//             ))
//           ) : (
//             <p className="text-gray-400 text-sm italic text-center">
//               No scheduled activities.
//             </p>
//           )}
//         </div>

//         {showActivityModal && (
//           <FollowUpPopup
//             onClose={() => {
//               setShowActivityModal(false);
//               setSelectedActivity({});
//             }}
//             CustomerData={selectedActivity}
//             tabIndex={2}
//             onError={onError}
//             onSubmit={onFollowUpSuccess}
//             id={activeProjectData?.projectid}
//             entitytype="project"
//             entityname={activeProjectData.projectname}
//             UsersList={UserList}
//           />
//         )}
//       </div>
//       {/* </div> */}
//     </>
//   );
// };

const Timeline = ({
  leadDetail,
  onSuccess = () => {},
  onError = () => {},
  activeProjectData = {},
}) => {
  return (
    <>
      <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto relative">
        {/* Project Activity */}

        <div className="bg-white rounded-[10px] border border-[#e1e4ea] p-5 flex flex-col gap-[10px]">
          {activeProjectData?.activities?.length ? (
            <div>
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-medium leading-normal">
                  Project Activity
                </h2>
              </div>

              <div className="flex flex-col h-full mt-5">
                <div className="flex-1 overflow-y-auto pr-4">
                  <div className="relative ml-1">
                    {/* ✅ Single clean vertical line */}

                    <>
                      <div className="absolute left-3 top-0 h-full border-l-2 border-gray-200"></div>
                      {activeProjectData?.activities?.map((act, i) => {
                        const userName = act?.user?.name || "U";
                        const userInitial = userName.charAt(0).toUpperCase();
                        const colors = [
                          "bg-emerald-500",
                          "bg-blue-500",
                          "bg-indigo-500",
                          "bg-rose-500",
                        ];
                        const userColor = "bg-slate-200";

                        return (
                          <div key={i} className="relative pl-10 pb-6">
                            {/* ✅ User Initial Circle */}
                            <div
                              className={`absolute left-0 top-0 flex items-center justify-center w-7 h-7 rounded-full bg-slate-200 text-slate-700 text-xs font-semibold`}
                            >
                              {userInitial}
                            </div>

                            {/* ✅ Activity content properly aligned */}
                            <div className="flex flex-col gap-1 pt-0.5">
                              <div className="flex justify-between items-center">
                                <p className="text-sm font-medium text-gray-800">
                                  {act.log}
                                </p>
                                <p className="text-xs text-gray-400">
                                  {act.logtime}
                                </p>
                              </div>

                              {act?.user?.name && (
                                <div className="flex items-center gap-1 text-xs text-gray-500">
                                  <User className="h-3 w-3 text-gray-400" />
                                  <span className="leading-none">
                                    by {act.user.name}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-gray-400">No Project acitivity available.</p>
          )}
        </div>
      </div>
    </>
  );
};

// const TimelineTab = ({
//   activeProjectData,
//   onError,
//   onSubmit,
//   UserList,
//   onFollowUpSuccess = () => {},
// }) => {
//   const [showActivityModal, setShowActivityModal] = useState(false);
//   const [selectedActivity, setSelectedActivity] = useState(null);
//   const [type, setType] = useState("");
//   return (
//     <div>
//       {activeProjectData?.activities?.length ? (
//         <>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 0,
//               position: "relative",
//             }}
//           >
//             {/* Quick log bar */}

//             <Card
//               style={{
//                 padding: "12px 16px",
//                 marginBottom: 12,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//             >
//               <span
//                 style={{ fontSize: 12, color: T.textMuted, fontWeight: 500 }}
//               >
//                 Quick log:
//               </span>
//               {[
//                 "Call",
//                 "Meeting",
//                 "Email",
//                 "Follow-up",
//                 "Demo",
//                 "Chat",
//                 "Consultation",
//                 "Presentation",
//               ].map((type) => (
//                 <button
//                   key={type}
//                   onClick={() => {
//                     if (typeof setSelectedActivity === "function") {
//                       setSelectedActivity(null);
//                       setType(type);
//                       console.log("type", type);
//                     }
//                     if (typeof setShowActivityModal === "function") {
//                       setShowActivityModal(true);
//                       setType(type);
//                     }
//                   }}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 5,
//                     padding: "5px 12px",
//                     borderRadius: 20,
//                     border: `1px solid ${activityColors[type?.toLocaleLowerCase() || "default"]}25`,
//                     background:
//                       activityColors[type?.toLocaleLowerCase()] + "08",
//                     color: activityColors[type?.toLocaleLowerCase()],
//                     cursor: "pointer",
//                     fontSize: 11,
//                     fontWeight: 600,
//                     fontFamily: "inherit",
//                   }}
//                 >
//                   <Icon
//                     name={activityIcons[type?.toLocaleLowerCase() || "default"]}
//                     size={12}
//                     color={
//                       activityColors[type?.toLocaleLowerCase() || "default"]
//                     }
//                   />
//                   {type.charAt(0).toUpperCase() + type.slice(1)}
//                 </button>
//               ))}
//             </Card>

//             {/* Timeline items */}
//             <div style={{ position: "relative", paddingLeft: 28 }}>
//               {/* Vertical line */}
//               <div
//                 style={{
//                   position: "absolute",
//                   left: 11,
//                   // top: 8,
//                   // bottom: 8,
//                   top: 15,
//                   bottom: 40,
//                   width: 2,
//                   background: "#ddd8d2",
//                   borderRadius: 1,
//                 }}
//               />

//               {activeProjectData?.activities?.map((a, i) => {
//                 const color =
//                   activityColors[a?.icon?.toLocaleLowerCase()] ||
//                   "#8b5cf6" ||
//                   "#6b7280";
//                 // const expanded = expandedActivity === a.id;
//                 return (
//                   <div
//                     key={a.id}
//                     style={{ position: "relative", marginBottom: 8 }}
//                   >
//                     {/* Dot */}
//                     <div
//                       style={{
//                         position: "absolute",
//                         left: -22,
//                         top: 16,
//                         width: 12,
//                         height: 12,
//                         borderRadius: "50%",
//                         background: color + "20",
//                         border: `2.5px solid ${color}`,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         zIndex: 1,
//                       }}
//                     >
//                       <div
//                         style={{
//                           width: 4,
//                           height: 4,
//                           borderRadius: "50%",
//                           background: color,
//                         }}
//                       />
//                     </div>

//                     <Card
//                       hover
//                       // onClick={() =>
//                       //   setExpandedActivity(expanded ? null : a.id)
//                       // }
//                       style={{ padding: "14px 18px" }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "flex-start",
//                           gap: 12,
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: 32,
//                             height: 32,
//                             borderRadius: 8,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             background: color + "12",
//                             flexShrink: 0,
//                           }}
//                         >
//                           <Icon
//                             name={
//                               activityIcons[
//                                 a?.icon?.toLocaleLowerCase() ?? "default"
//                               ]
//                             }
//                             size={14}
//                             color={color}
//                           />
//                         </div>
//                         <div style={{ flex: 1, minWidth: 0 }}>
//                           <div
//                             style={{
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "space-between",
//                               gap: 8,
//                             }}
//                           >
//                             <span
//                               style={{
//                                 fontSize: 13,
//                                 fontWeight: 600,
//                                 color: T.text,
//                               }}
//                             >
//                               {a.log}
//                             </span>
//                           </div>
//                           <div
//                             style={{
//                               display: "flex",
//                               gap: 12,
//                               marginTop: 5,
//                               fontSize: 11,
//                               color: T.textMuted,
//                             }}
//                           >
//                             <span>{a?.logtime}</span>
//                             <span>by {a.user.name}</span>
//                           </div>
//                         </div>
//                       </div>
//                     </Card>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </>
//       ) : (
//         <p className="text-gray-400 text-sm italic text-center">
//           No timeline available.
//         </p>
//       )}

//       {showActivityModal && (
//         <FollowUpPopup
//           onClose={() => {
//             setShowActivityModal(false);
//             setSelectedActivity({});
//           }}
//           CustomerData={{
//             entity_type: "project",
//             entity_name: activeProjectData?.name,
//             entity_id: activeProjectData?.projectid,
//           }}
//           tabIndex={2}
//           onError={onError}
//           onSubmit={onFollowUpSuccess}
//           id={activeProjectData?.projectid}
//           UsersList={UserList}
//           type={type.toLowerCase()}
//         />
//       )}
//     </div>
//   );
// };

const Comments = ({ activeProjectData, updateCount = () => {} }) => {
  return (
    <>
      <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto relative">
        <div className="space-y-4 h-full">
          <CommentsSection
            type="project"
            id={activeProjectData.projectid}
            apiBaseUrl="project"
            title="true"
            data={activeProjectData}
            updateCount={updateCount}
            HasPopupUi={false}
          />
        </div>
      </div>
    </>
  );
};
const Files = ({ activeProjectData, updateCount = () => {} }) => {
  return (
    <>
      <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto">
        <FilesTab
          leadId={activeProjectData?.projectid}
          attachments={activeProjectData?.attachments}
          attachmenttype="project"
          data={activeProjectData}
          updateCount={updateCount}
        />
      </div>
    </>
  );
};

// const Brief = ({ activeProjectData }) => {
//   return (
//     <>
//       <div className="flex flex-col gap-[10px]  w-full h-full overflow-auto ">
//         <div className="bg-white rounded-[10px] p-5  border border-[#e1e4ea]  flex flex-col gap-[10px]">
//           {activeProjectData?.briefs?.length > 0 ? (
//             <div>
//               <div className="flex items-center justify-between">
//                 <h2 className="text-xl font-medium leading-normal">
//                   Project Brief
//                 </h2>
//               </div>
//               {Array.isArray(activeProjectData?.briefs) && (
//                 <div className="divide-y divide-slate-200">
//                   {activeProjectData.briefs.map((item, index) => {
//                     // 🧠 Replace all URLs in answer with clickable links showing clean names
//                     const formattedAnswer = item.answer
//                       ? item.answer.replace(/(https?:\/\/[^\s,]+)/g, (url) => {
//                           try {
//                             const parts = url.split("/");
//                             const fileName = parts[parts.length - 1];

//                             // 🧩 Check if it looks like a file link
//                             const isFile = /\.[a-zA-Z0-9]{2,5}($|\?)/.test(
//                               fileName,
//                             );

//                             let displayText;
//                             if (isFile) {
//                               // Example: Trina-Sandell---2025Resume.pdf
//                               displayText = decodeURIComponent(fileName);
//                             } else {
//                               // Example: linkedin.com/in/trina-sandell-2b040225
//                               const domain = new URL(url).hostname.replace(
//                                 "www.",
//                                 "",
//                               );
//                               const path = new URL(url).pathname.replace(
//                                 /^\/|\/$/g,
//                                 "",
//                               );
//                               displayText = `${domain}/${path}`.slice(0, 60); // Trim long paths
//                             }

//                             return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">${displayText}</a>`;
//                           } catch {
//                             return url;
//                           }
//                         })
//                       : "—";

//                     // Add space between multiple links for readability
//                     const spacedAnswer = formattedAnswer.replace(
//                       /<\/a>\s*(?=<a )/g,
//                       "</a> &nbsp;&nbsp;",
//                     );

//                     return (
//                       <div key={index} className="py-4">
//                         <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
//                           <div className="sm:w-1/3">
//                             <h3 className="text-sm font-semibold text-slate-700">
//                               {item.question}
//                             </h3>
//                           </div>
//                           <div className="sm:flex-1">
//                             <p
//                               className="text-sm text-slate-600 leading-relaxed whitespace-pre-line break-words"
//                               dangerouslySetInnerHTML={{ __html: spacedAnswer }}
//                             ></p>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               )}
//             </div>
//           ) : (
//             <p className="text-gray-400 italic text-sm">
//               No brief data available.
//             </p>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

const Brief = ({
  activeProjectData,
  onUpdateBrief,
  onSubmit = () => {},
  onError = () => {},
  loadActiveProject = () => {},
}) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [addBrief, setAddBrief] = useState(false);
  const [editedData, setEditedData] = useState({ question: "", answer: "" });

  const [projectBrief, setProjectBrief] = useState(
    activeProjectData?.briefs || [],
  );

  // Start editing a field
  const handleEditClick = (item, index) => {
    setEditingIndex(index);
    setEditedData({ question: item.question, answer: item.answer });

    console.log("Item", item);
  };

  // Cancel editing
  const handleCancel = () => {
    setEditingIndex(null);
    setEditedData({ question: "", answer: "" });
  };

  // Save the edited data
  const handleSave = async (brief_id, item) => {
    // If question is not editable, send original
    const questionToSend =
      item.is_editable == 1 ? editedData.question : item.question;

    const previousBriefs = [...projectBrief];

    // 1️⃣ Update UI immediately
    const updatedBriefs = projectBrief?.map((brief) =>
      brief?.id === brief_id
        ? { ...brief, question: questionToSend, answer: editedData?.answer }
        : brief,
    );
    setProjectBrief(updatedBriefs);
    setEditingIndex(null);

    try {
      await onUpdateBrief({
        brief_id,
        question: questionToSend,
        answer: editedData.answer,
      });

      // ✅ If success → do nothing (UI already updated)
    } catch (error) {
      // ❌ If API fails → rollback UI
      setProjectBrief(previousBriefs);
    }
  };

  // Format answer to make URLs clickable
  const formatAnswer = (answer) => {
    if (!answer) return "—";

    const formattedAnswer = answer.replace(/(https?:\/\/[^\s,]+)/g, (url) => {
      try {
        const parts = url.split("/");
        const fileName = parts[parts.length - 1];
        const isFile = /\.[a-zA-Z0-9]{2,5}($|\?)/.test(fileName);
        let displayText;
        if (isFile) displayText = decodeURIComponent(fileName);
        else {
          const domain = new URL(url).hostname.replace("www.", "");
          const path = new URL(url).pathname.replace(/^\/|\/$/g, "");
          displayText = `${domain}/${path}`.slice(0, 60);
        }
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline break-all">${displayText}</a>`;
      } catch {
        return url;
      }
    });

    return formattedAnswer.replace(/<\/a>\s*(?=<a )/g, "</a> &nbsp;&nbsp;");
  };

  const handleBriefSuccess = (message) => {
    if (onSubmit) onSubmit(message);
    setAddBrief(false);
    loadActiveProject();
  };

  return (
    <>
      <div className="flex flex-col gap-4 w-full h-full overflow-auto">
        {/* <div className="bg-white rounded-xl p-5 border border-[#e1e4ea] flex flex-col gap-4"> */}

        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Card
            style={{
              padding: "12px 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontSize: 13, fontWeight: 600 }}>Brief</span>
            <ActionButton
              icon="plus"
              label="Add Brief"
              variant="filled"
              style={{ width: "auto", padding: "7px 14px", fontSize: 12 }}
              onClick={() => setAddBrief(true)}
            />
          </Card>
        </div>
        {projectBrief?.length > 0 ? (
          <>
            {/* <div className="flex items-center justify-between">
                <h2 className="text-xl font-medium">Project Brief</h2>
                <div
                  className={Style.bpfl_action}
                  onClick={() => setAddBrief(true)}
                >
                  <Tooltip
                    content={"Add Brief"}
                    position={"left center"}
                    className="bg-[#0057FB] text-white flex text-[12px] p-1  items-center gap-1  cursor-pointer transition-all duration-200 hover:scale-105 hover:bg-[#095bf3]"
                  >
                    <div className={Style.icon}>
                      <PlusIcon size="16px" />
                    </div>
                  </Tooltip>
                </div>
              </div> */}

            <div className="divide-y divide-slate-200 bg-white rounded-xl  border border-[#e1e4ea] flex flex-col">
              {/* flex flex-col gap-1 */}
              {projectBrief?.map((item, index) => {
                const isEditing = editingIndex === index;

                return (
                  // <Card
                  //   key={index}
                  //   style={{
                  //     padding: "12px 16px",
                  //   }}
                  // >
                  <div
                    style={{
                      padding: "12px 16px",
                    }}
                  >
                    <div className="flex flex-col sm:flex-row sm:items-start sm:gap-4">
                      {/* Question */}
                      <div className="sm:w-1/3 flex items-center justify-between">
                        {isEditing && item.is_editable == 1 ? (
                          <input
                            type="text"
                            className="w-full border border-gray-300 rounded px-2 py-1 text-sm font-semibold text-slate-700"
                            value={editedData.question}
                            onChange={(e) =>
                              setEditedData((prev) => ({
                                ...prev,
                                question: e.target.value,
                              }))
                            }
                          />
                        ) : (
                          <h3 className="text-sm font-semibold text-slate-700">
                            {item.question}
                          </h3>
                        )}

                        <span className="ml-2">
                          {item.is_editable == 1 ? (
                            <Pencil
                              className="w-4 h-4 text-gray-500 cursor-pointer hover:text-blue-500"
                              onClick={() => handleEditClick(item, index)}
                            />
                          ) : (
                            <Lock className="w-4 h-4 text-gray-400" />
                          )}
                        </span>
                      </div>

                      {/* Answer */}
                      <div className="sm:flex-1 mt-2 sm:mt-0 relative">
                        <div className="w-full flex items-center justify-between">
                          <>
                            {isEditing ? (
                              <textarea
                                className="w-full border min-h-10 max-h-20 border-gray-300 rounded p-2 text-sm text-slate-600 leading-relaxed whitespace-pre-line break-words"
                                value={editedData.answer}
                                onChange={(e) =>
                                  setEditedData((prev) => ({
                                    ...prev,
                                    answer: e.target.value,
                                  }))
                                }
                                rows={3}
                              />
                            ) : (
                              <p
                                className="text-sm text-slate-600 leading-relaxed whitespace-pre-line break-words"
                                dangerouslySetInnerHTML={{
                                  __html: formatAnswer(item.answer),
                                }}
                              ></p>
                            )}
                          </>

                          {!isEditing && (
                            <span className="ml-2">
                              <Pencil
                                className="w-4 h-4 text-gray-500 cursor-pointer hover:text-blue-500"
                                onClick={() => handleEditClick(item, index)}
                              />
                            </span>
                          )}
                        </div>
                        {/* Save / Cancel buttons */}
                        {isEditing && (
                          <div className="mt-2 flex gap-2">
                            <button
                              className="flex items-center gap-1 text-white bg-[#6366f1] px-3 py-1 rounded hover:shadow text-sm"
                              onClick={() => handleSave(item?.id, item)}
                            >
                              <Check className="w-4 h-4" /> Save
                            </button>
                            <button
                              className="flex items-center gap-1 text-gray-700 bg-gray-200 px-3 py-1 rounded hover:bg-gray-300 text-sm"
                              onClick={handleCancel}
                            >
                              <X className="w-4 h-4" /> Cancel
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  // </Card>
                );
              })}
            </div>
          </>
        ) : (
          <div className="flex justify-center items-center ">
            <p className="text-gray-400 italic text-sm ">
              No brief data available.
            </p>

            {/* <div
              className={Style.bpfl_action}
              onClick={() => setAddBrief(true)}
            >
              <Tooltip
                content={"Add Brief"}
                position={"left center"}
                className="bg-[#0057FB] text-white flex text-[12px] p-1  items-center gap-1  cursor-pointer transition-all duration-200 hover:scale-105 hover:bg-[#095bf3]"
              >
                <div className={Style.icon}>
                  <PlusIcon size="16px" />
                </div>
              </Tooltip>
            </div> */}
          </div>
        )}
      </div>
      {/* </div> */}

      {addBrief ? (
        <AddBrief
          projectkey={activeProjectData?.projectkey}
          onClose={() => {
            setAddBrief(false);
          }}
          onSubmit={handleBriefSuccess}
          onError={onError}
        />
      ) : null}
    </>
  );
};

const ProjectTab = ({
  leadDetail,
  onSuccess = () => {},
  onError = () => {},
  loading = () => {},
  activeProjectData = {},
  loadActiveProject = () => {},
  updateProjectData = () => {},
  clientProjects = [],
  UsersList = [],
  onFollowUpSuccess = () => {},
  updateCount = () => {},
  followUp = "",
  followUpID = "",
}) => {
  const apiCall = useApiCall();

  const [alertData, setAlertData] = useState({ isShow: false });
  const [statusList, setStatusList] = useState([]);

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "get-dropdown-list",
      });

      console.log(res?.data);
      setStatusList(res?.data?.project_status || []);
    } catch (error) {
      console.warn("Error fetching Package:", error);
    }
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const onSuccessBrief = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
  };

  const onUpdateBrief = async ({ brief_id, question, answer }) => {
    console.log(brief_id, question, answer);

    try {
      let data = {
        brief_id,
        question,
        answer,
      };
      let apiRes = await apiCall({
        method: "post",
        url: `project/update-project-brief`,
        data: data,
      });

      onSuccessBrief(apiRes?.message || `Request Submitted`);
      return apiRes;
    } catch (error) {
      console.log(error);
      onError(
        error?.response.data?.respMsg ||
          error?.response.data?.responseMessage ||
          error?.response.data?.message ||
          "Some Thing Went Wrong",
      );
      throw error;
    }
  };

  const handleStatusUpdate = async (newStatus) => {
    console.log(newStatus);
    try {
      let apiRes = await apiCall({
        method: "post",
        url: "project/update-project-status",
        data: { project_key: activeProjectData.projectkey, status: newStatus },
      });

      onSuccessBrief(apiRes?.message || `Request Submitted`);
      console.log("clientProject", clientProjects);
      console.log("activeProjectData", activeProjectData);

      const updatedCLientProject = clientProjects?.map((eachList) =>
        eachList.projectid == activeProjectData.projectid
          ? {
              ...eachList,
              status: newStatus,
            } // new object
          : eachList,
      );

      updateProjectData(
        {
          ...activeProjectData,
          status: newStatus,
        },
        updatedCLientProject,
      );
      return apiRes;
    } catch (error) {
      console.log(error);
      onError(
        error?.response.data?.respMsg ||
          error?.response.data?.responseMessage ||
          error?.response.data?.message ||
          "Some Thing Went Wrong",
      );
      throw error;
    }
  };

  const TabButton = ({ active, label, count, onClick }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <button
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          padding: "8px 16px",
          borderRadius: 8,
          border: "none",
          background: active
            ? T.accent
            : hovered
              ? "rgba(0,0,0,0.04)"
              : "transparent",
          color: active ? "#fff" : hovered ? T.text : T.textSecondary,
          cursor: "pointer",
          fontSize: 13,
          fontWeight: active ? 600 : 500,
          fontFamily: "inherit",
          transition: "all 0.15s",
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        {label}
        {count !== undefined && (
          <span
            style={{
              background: active
                ? "rgba(255,255,255,0.25)"
                : "rgba(0,0,0,0.06)",
              padding: "1px 7px",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 600,
              color: active ? "#fff" : T.textMuted,
            }}
          >
            {count}
          </span>
        )}
      </button>
    );
  };

  const TAB_CONFIG = [
    {
      key: "timeline",
      label: "Timeline",
      component: (
        // <Timeline
        //   activeProjectData={activeProjectData}
        //   loading={loading}
        //   onSuccess={onSuccess}
        //   onError={onError}
        // />
        <TimelineTab
          leadDetail={activeProjectData}
          UsersList={UsersList}
          onSubmit={onFollowUpSuccess}
          onError={onError}
          MainIndex="2"
        />
      ),
      count: activeProjectData?.activities_count,
    },
    {
      key: "project",
      label: "Details",
      component: (
        <Project
          activeProjectData={activeProjectData}
          loading={loading}
          onSuccess={onSuccess}
          onError={onError}
          statusList={statusList}
          onChange={handleStatusUpdate}
        />
      ),
    },
    {
      key: "followups",
      label: "Follow ups",
      component: (
        // <FollowUpsTab
        //   leadDetail={leadDetail}
        //   activeProjectData={activeProjectData}
        //   onSubmit={onSuccess}
        //   onError={onError}
        //   UserList={UsersList}
        //   onFollowUpSuccess={onFollowUpSuccess}
        // />

        <FollowUpsTab
          leadDetail={activeProjectData}
          onSubmit={onFollowUpSuccess}
          onError={onError}
          UsersList={UsersList}
          id={activeProjectData?.projectid}
          entitytype="project"
          entityname={activeProjectData.projectname}
          followUpID={followUpID}
        />
      ),
      count: activeProjectData?.schedules_count,
    },

    {
      key: "comments",
      label: "Comments",
      component: (
        <Comments
          leadDetail={leadDetail}
          activeProjectData={activeProjectData}
          updateCount={updateCount}
          onSubmit={onSuccess}
          onError={onError}
        />
      ),
      count: activeProjectData?.comments_count,
    },
    {
      key: "files",
      label: "Files",
      component: (
        <Files
          leadId={activeProjectData?.userid}
          attachments={activeProjectData?.attachments}
          attachmenttype="contact"
          activeProjectData={activeProjectData}
          onSubmit={onSuccess}
          onError={onError}
          updateCount={updateCount}
        />
      ),
      count: activeProjectData?.attachments_count,
    },
    {
      key: "briefs",
      label: "Briefs",
      component: (
        <Brief
          leadId={activeProjectData?.userid}
          attachments={activeProjectData?.attachments}
          attachmenttype="contact"
          activeProjectData={activeProjectData}
          onSubmit={onSuccessBrief}
          onError={onError}
          onUpdateBrief={onUpdateBrief}
          loadActiveProject={loadActiveProject}
        />
      ),
      count: activeProjectData?.briefs_count,
    },
  ].filter(Boolean);

  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (followUp) {
      setTab(2);
    }
  }, []);

  const [tabsCustomizeTabs, setTabsCustomizeTabs] = useState({
    project: true,
    followups: true,
    timeline: true,
    comments: true,
    files: true,
    briefs: true,
  });

  const handleTabChange = (index) => {
    setTab(index);
  };

  const renderedTabs = useMemo(() => {
    return TAB_CONFIG.map((tabItem, index) => {
      if (tabItem.key !== "timeline" && !tabsCustomizeTabs[tabItem.key])
        return null;
      return (
        <TabButton
          key={tabItem.key}
          active={tab === index}
          label={tabItem.label}
          count={tabItem.count}
          onClick={() => {
            if (tabItem?.component) {
              handleTabChange(index);
            }

            if (tabItem.key == "timeline") {
              loadActiveProject();
            }
          }}
        />
      );
    });
  }, [tab, tabsCustomizeTabs, activeProjectData]);

  return (
    <>
      {/* <div> */}
      {loading || !activeProjectData?.projectid ? (
        <div className="w-full h-full flex justify-center items-center">
          <InnerLoader />
        </div>
      ) : (
        <>
          <Card
            style={{
              padding: "6px 8px",
              display: "flex",
              gap: 4,
              flexWrap: "wrap",
            }}
          >
            {renderedTabs}
          </Card>

          <div className="flex flex-col h-screen overflow-auto">
            {TAB_CONFIG.map(
              (tabItem, index) =>
                //   <div>
                tab === index && (
                  <Suspense
                    key={tabItem?.key}
                    fallback={
                      <div className="tableDataLoader">
                        <div className="tableDataLoader-wrapper">
                          <div className="loader"></div>
                          <span>Data Load...</span>
                        </div>
                      </div>
                    }
                  >
                    {tabItem?.component}
                  </Suspense>
                ),
              //   </div>
            )}
          </div>
        </>
      )}

      {show && (
        <CustomizeTabsOverviewPopup
          data={TAB_CONFIG.map((t) => t)}
          tabs={tabsCustomizeTabs}
          onClose={() => setShow(false)}
          onToggle={(tabName) => {
            if (tabName === "project") return; //
            setTabsCustomizeTabs((prev) => ({
              ...prev,
              [tabName]: !prev[tabName],
            }));
            handleTabChange(0);
          }}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProjectTab;
